/**
 * Per-overlay brand resolution (two-stage seam):
 *   VITE_BRAND=godgift  →  branding/godgift/strings.json
 *
 * When a second client overlay lands, add `branding/<slug>/` and flip VITE_BRAND at build.
 * Platform-tier loader; the strings themselves are overlay content.
 */

import strings from '../../branding/godgift/strings.json';

export type BrandStrings = {
  heading?: string;
  tagline?: string;
  start_label?: string;
  listening_label?: string;
  consent_short?: string;
  request_callback?: string;
  try_asking?: string[];
  // R15 T1 — S0 attract/welcome resting scene copy. Client-approved positioning set (landed
  // 2026-07-16, 971c23c — house blurb + the "2,000+ pieces / 13 categories" stat; R46 §Needs-Andy
  // decisions 1–3 resolved). Overlay content — the strings live in branding/godgift/strings.json.
  attract_title?: string;
  attract_lines?: string[];
  attract_stat?: string;
  attract_cue?: string;
  [key: string]: string | string[] | undefined;
};

export const BRAND = strings as BrandStrings;
